/* eslint-disable no-mixed-operators */
/* eslint-disable no-multi-spaces */
/* eslint-disable no-underscore-dangle */
import { createSelector } from 'reselect'

import { getAuthUser } from '../auth/auth-selector'

import moment from '../../lib/moment'
import { momentFormatter } from '../../lib/utils'

const ppsSelector = state => state.get('pps')
const ppsImportActualSelector = state => state.getIn(['pps', 'pps_import_actual'])

export const isAuthorize = createSelector(
  getAuthUser,
  user =>
    user.is_system_admin    ||
    user.is_management_role ||
    user.is_vp_avp_role     ||
    user.is_pm_role         ||
    user.is_lob_lead_role   ||
    user.is_accountant_role ||
    user.is_display_pps_role
)

export const isFetching = createSelector(ppsSelector, pps => pps.get('is_fetching'))
export const isManualOpen = createSelector(ppsSelector, pps => pps.get('is_manual_open'))
export const showAccounting = createSelector(ppsSelector, pps => pps.get('show_accounting'))
export const display = createSelector(ppsSelector, data => data.get('display'))
export const profitData = createSelector(ppsSelector, pps => pps.get('profit_data').toJS())
export const otherCostEditing = createSelector(
  ppsSelector,
  pps => pps
    .get('other_cost_editing')
    .map(rec => rec.update('date', date => date || moment()))
)
export const canSaveProgress = createSelector(ppsSelector, pps => pps.get('can_save_progress'))
export const percentTable = createSelector(ppsSelector, pps => pps.get('percent_table').toJS())
export const responseModal = createSelector(ppsSelector, pps => pps.get('response_modal').toJS())
export const submitMonth = createSelector(ppsSelector, pps => pps.get('submit_month'))
export const importDetail = createSelector(ppsSelector, pps => pps.get('import_detail').toJS())
export const getAlert = createSelector(ppsSelector, pps => {
  const err = pps.get('alert')
  return err ? err.toJS() : err // Immutable.Map | null
})
export const getUnapprovedUsers = createSelector(
  ppsSelector,
  pps => pps.get('unapproved_timesheets').toJS()
)

export const overviews = createSelector(
  ppsSelector,
  pps => pps
    .get('overviews')
    .map(data => data
      .update('start_date', momentFormatter('DD/MM/YYYY'))
      .update('end_date', momentFormatter('DD/MM/YYYY'))
      .update('latest_submit', momentFormatter('MM/YYYY')))
    .toJS()
)

export const submits = createSelector(
  ppsSelector,
  pps => pps
    .get('submits')
    .map(data => data
      .update('start_date', momentFormatter('DD/MM/YYYY'))
      .update('end_date', momentFormatter('DD/MM/YYYY'))
      .update('latest_submit', momentFormatter('MM/YYYY')))
    .toJS()
)

export const accountingCosts = createSelector(
  ppsSelector,
  pps => pps
    .get('accounting_costs')
    .map(data => data
      .update('date', momentFormatter('DD/MM/YYYY')))
    .toJS()
)

export const progresses = createSelector(
  ppsSelector,
  pps => pps.get('progresses').toJS()
)

export const isSubmitPPS = createSelector(
  ppsSelector,
  pps => pps.get('is_submit_pps')
)

export const updatedProgresses = createSelector(
  ppsSelector,
  pps => pps.get('updateProjectProgress').toJS()
)

export const disableSaveOtherCost = createSelector(
  otherCostEditing,
  list => list.some(value => value.get('type') === '-')
)

export const canSubmit = createSelector(profitData, data => data.can_submit)
export const privileged = createSelector(profitData, data => [
  true,
  data.can_display_standard_cost,
  data.can_display_actual_cost,
])
export const profitID = createSelector(profitData, data => data._id)
export const projectCode = createSelector(profitData, data => data.project_code)
export const projectID = createSelector(profitData, data => data.project_id)
export const startDate = createSelector(profitData, data => moment(data.start_date))
export const otherCost = createSelector(profitData, data => data.other_costs || [])
export const canEditCost = createSelector(profitData, data => data.submit_date)
export const costSums = createSelector(profitData, data => ({
  vendor: data.sumVendor,
  hardware: data.sumHardware,
  license: data.sumLicense,
  other_cost: data.sumOtherCost,
}))

export const importFetching = createSelector(
  ppsImportActualSelector,
  ppsImportActual => ppsImportActual.get('is_fetching')
)
export const status = createSelector(
  ppsImportActualSelector,
  ppsImportActual => ppsImportActual.get('status').toJS()
)
export const transactions = createSelector(
  ppsImportActualSelector,
  ppsImportActual => ppsImportActual.get('transaction').toJS()
)

export const canUseAccountantActions = createSelector(
  getAuthUser,
  showAccounting,
  (user, showAcc) => user.is_accountant_role && showAcc
)

export const isDisplayPPSUser = createSelector(
  getAuthUser,
  user => user.is_display_pps_role
)



// WEBPACK FOOTER //
// ./src/selectors/project-profit-sheet/index.js